import { backendAPI } from '../../helper/apis';

export const sendPushNotification = (params) => backendAPI.post('/sendPush', params);
